module.exports = __webpack_public_path__ + "img/ZW.3526099a.png";